export const MAX_FILE_SIZE_MB = 200;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
export const CTRLX = "ctrlX"
export const DRAGDROP = "dragDrop";
export const CHUNK_SIZE = 5 * 1024 * 1024;